<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">主控设备管理</div>

      <div class="search-wrapper">
         <el-form inline :model="formParam">
            <el-form-item label="校区名称">
               <el-select placeholder="请选择校区" v-model="formParam.schoolId" filterable clearable @change="changeSchool">
                  <el-option v-for="(item, index) in schoolOptions" :key="index" :label="item.name"
                     :value="item.rootUnid">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="序列号">
               <el-input placeholder="请输入序列号" clearable :maxlength="100" v-model="formParam.sn"></el-input>
            </el-form-item>
            <el-form-item label="设备名称">
               <el-input placeholder="请输入设备名称" clearable :maxlength="100" v-model="formParam.name"></el-input>
            </el-form-item>
            <el-form-item label="设备类型">
               <el-select placeholder="请选择类型" v-model="formParam.type" filterable clearable>
                  <el-option label="全部" value></el-option>
                  <el-option v-for="(item, index) in typeOptions" :key="index" :label="item.label" :value="item.value">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="是否配置主控">
               <el-select v-model="formParam.hasMasterDevice">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item>
               <el-button type="primary" @click="clickQuery">搜索</el-button>
               <el-button @click="clickReset">重置</el-button>
            </el-form-item>
         </el-form>
      </div>

      <div class="initial-state">
         <el-button v-if="settingInfo.masterDeviceSwitch" type="danger" @click="clickCloseControl">关闭主控设置</el-button>
         <div v-else class="status-box">
            <div class="status-title">当前学校未开启"主控机器"功能</div>
            <el-button type="primary" @click="clickOpenControl">开启主控设置</el-button>
         </div>
         <div class="tip-box">
            <div class="tip-line"></div>
            <span class="tips-text">本列表用于查看/管理外接筒机、超脑的主控机器，主控机器主要用于对设备进行“人脸同步/更新”操作</span>
         </div>
      </div>

      <div class="content-wrapper margin-top-20 margin-bottom-20" v-if="settingInfo.masterDeviceSwitch">
         <table class="custom-table">
            <thead>
               <tr>
                  <th>设备序列号</th>
                  <th>已绑设备信息</th>
                  <th>设备名称（设备类型）</th>
                  <th>主控设备</th>
               </tr>
            </thead>
            <tbody>
               <tr v-for="(row, index) in dataList" :key="index">
                  <td :rowspan="handleSpanMethod({ row, column: null, rowIndex: index, columnIndex: 0 }).rowspan"
                     v-if="handleSpanMethod({ row, column: null, rowIndex: index, columnIndex: 0 }).rowspan">
                     {{ row.sn }}
                  </td>
                  <td :rowspan="handleSpanMethod({ row, column: null, rowIndex: index, columnIndex: 1 }).rowspan"
                     v-if="handleSpanMethod({ row, column: null, rowIndex: index, columnIndex: 1 }).rowspan">
                     {{ `${row.name}（${getDeviceTypeName(row.type)}）` }}
                     <span class="label-controlled" v-if="row.isMasterDevice">主控</span>
                  </td>
                  <td>{{ `${row.externalDeviceName}（${row.externalDeviceType}）` }}</td>
                  <td :rowspan="handleSpanMethod({ row, column: null, rowIndex: index, columnIndex: 3 }).rowspan"
                     v-if="handleSpanMethod({ row, column: null, rowIndex: index, columnIndex: 3 }).rowspan">
                     <button class="text-button" :class="{ 'button-uncontrol': !hasMasterDevice(row) }"
                        @click="clickEdit(row)">
                        {{ handleMasterDevice(row) }}
                     </button>
                  </td>
               </tr>
            </tbody>
         </table>

      </div>

      <el-dialog title="请选择主控设备" size="tiny" v-model="editParam.visible" :close-on-click-modal="false"
         :modal-append-to-body="false" destroy-on-close>
         <el-radio-group v-model="editParam.selectedDevice" class="flex-row gap-10">
            <el-radio v-for="(item, index) in editParam.deviceList" :key="index" :label="item.uid">
               {{ item.name + '(' + getDeviceTypeName(item.type) + ')' }}
            </el-radio>
         </el-radio-group>
         <template #footer center>
            <el-button @click="editParam.visible = false">取消</el-button>
            <el-button type="primary" @click="clickEditDone">确定</el-button>
         </template>
      </el-dialog>

   </div>
</template>

<script>
import { externalDeviceTypesConst } from "../../../../common/constant.js";

export default {
   data() {
      return {
         loading: false,
         formParam: {
            schoolId: '',
            sn: '',
            name: '',
            type: '',
            hasMasterDevice: '',
            pageNum: 1,
            pageSize: 10,
         },
         schoolOptions: [],
         typeOptions: [],
         settingInfo: {},
         dataList: [],
         totalCount: 0,
         editParam: {
            visible: false,
            deviceList: [],
            selectedDevice: ''
         }
      }
   },

   mounted() {
      this.queryAllSchool();
      this.typeOptions = externalDeviceTypesConst;
   },

   methods: {
      // 获取所有学校
      queryAllSchool() {
         this.loading = true;
         this.$http({
            method: "get",
            url: this.$util.domain + "/adminapi/v1/basicTools/schoolList",
         }).then((response) => {
            if (response.data.error == 10000) {
               this.schoolOptions = response.data.data;
               if (this.schoolOptions.length > 0) {
                  let item = this.schoolOptions[this.schoolOptions.length - 1];
                  this.formParam.schoolId = item.rootUnid;
               }
            } else {
               this.$util.errorMsg(response.data.message);
            }
         }).finally(() => {
            this.loading = false;
         });
      },

      // 查询学校设置信息
      querySettingInfo() {
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/basic/school/v260/info',
            params: { schoolId: this.formParam.schoolId },
            headers: { channelCode: this.$util.envType == 'pre' ? 'iydsjpre' : 'iydsj' },
         }).then((res) => {
            if (res.data && JSON.stringify(res.data) !== '{}') {
               this.settingInfo = { ...res.data.data };
            } else {
               this.settingInfo = {};
            }
         }).catch(() => {
            this.settingInfo = {};
         }).finally(() => {
            this.clickQuery();
         })
      },

      // 更新主控设置状态
      updateMasterDeviceSwitch(isOpen) {
         this.loading = true;
         this.$http({
            method: 'post',
            url: this.$util.aioIP + '/api/m/basic/school/v260/update',
            body: JSON.stringify({
               ...this.settingInfo,
               masterDeviceSwitch: isOpen
            }),
            headers: { channelCode: this.$util.envType == 'pre' ? 'iydsjpre' : 'iydsj' },
         }).then((res) => {
            if (res.data && res.data.code === 'ok') {
               this.$util.successMsg(isOpen ? '开启成功' : '关闭成功');
               this.settingInfo.masterDeviceSwitch = isOpen;
               isOpen && this.queryList();
            } else {
               this.$util.errorMsg(res.data.msg || '操作失败');
            }
         }).catch(() => {
            this.settingInfo = {};
         }).finally(() => {
            this.loading = false;
         })
      },

      // 查询列表
      queryList() {
         this.loading = true;
         this.$http({
            method: "get",
            url: this.$util.aioIP + '/api/m/hw/master/v430/list',
            params: this.formParam,
            headers: { channelCode: this.$util.envType == 'pre' ? 'iydsjpre' : 'iydsj' },
         }).then((response) => {
            if (response.data.data && JSON.stringify(response.data.data) !== '[]') {
               let tmpList = [];
               response.data.data.forEach((item) => {
                  const devices = item.bindDevices.map((device) => ({
                     ...device,
                     sn: item.sn,
                  }))
                  tmpList = tmpList.concat(devices);
               })
               this.dataList = tmpList;   // 列表数据
               this.totalCount = response.data.data.length; // 总条数
            } else {
               this.dataList = [];
               this.totalCount = 0;
            }
         }).catch((error) => {
            this.$util.errorMsg(error.data.msg);
         }).finally(() => {
            this.loading = false;
         });
      },

      // 绑定主控设备
      updateMainControl(sn, uid) {
         this.$http({
            method: "post",
            url: this.$util.aioIP + '/api/m/hw/master/v430/update',
            body: JSON.stringify({ sn, uid }),
         }).then((response) => {
            if (response.data.data) {
               this.$util.successMsg('设置成功');
               this.queryList();
               this.editParam.visible = false;
            } else {
               this.$util.errorMsg(response.data.msg || '设置失败');
            }
         }).catch(() => {
            this.$util.errorMsg('设置失败');
         });
      },

      // 切换校区
      changeSchool() {
         if (this.formParam.schoolId) {
            this.querySettingInfo();
         }
      },

      // 点击搜索
      clickQuery() {
         this.formParam.pageNum = 1;
         this.formParam.pageSize = 10;
         this.queryList();
      },

      // 点击重置
      clickReset() {
         this.formParam = {
            schoolId: '',
            sn: '',
            name: '',
            type: '',
            hasMasterDevice: '',
            pageNum: 1,
            pageSize: 10,
         };
         this.queryList();
      },

      // 开启主控设置
      clickOpenControl() {
         this.$confirm('开启后，当前学校下所有的外接设备添加时都需要设置：主控的机器，人脸只由“主控机器”进行同步/更新操作', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
         }).then(() => {
            this.updateMasterDeviceSwitch(true);
         }).catch(() => { })
      },

      // 关闭主控设置
      clickCloseControl() {
         this.$confirm('是否确认关闭主控设置？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
         }).then(() => {
            this.updateMasterDeviceSwitch(false);
         }).catch(() => { })
      },

      // 编辑
      clickEdit(row) {
         this.editParam.visible = true;
         // 先过滤出相同 sn 的设备，然后用 Set 根据 uid 去重
         const sameSnDevices = this.dataList.filter(item => item.sn === row.sn);
         const uniqueDevices = Array.from(new Map(sameSnDevices.map(item => [item.uid, item])).values());
         this.editParam.deviceList = uniqueDevices;
         this.editParam.selectedDevice = uniqueDevices.find((item) => item.isMasterDevice).uid || '';
      },

      // 点击编辑弹窗确定
      clickEditDone() {
         if (!this.editParam.selectedDevice) {
            this.$util.errorMsg('请选择主控设备');
            return;
         }
         const sn = this.editParam.deviceList.find(item => item.uid === this.editParam.selectedDevice).sn || '';
         this.updateMainControl(sn, this.editParam.selectedDevice);
      },

      // 获取设备类型名称
      getDeviceTypeName(type) {
         const typeMap = {
            0: '一体机',
            1: '坐位体前屈',
            2: '体检一体机',
            3: '智慧平板',
            4: 'Led',
            5: '智慧体育盒子',
            6: '二代一体机',
            7: '高校智慧体育盒子',
            8: 'AI体锻小站',
            9: '智慧体育盒子（场馆监控）'
         };
         return typeMap[type] || '未知类型';
      },

      // 判断是否有主控设备
      hasMasterDevice(row) {
         return this.dataList.filter(item => {
            return item.sn === row.sn;
         }).some(item => {
            return item.isMasterDevice;
         })
      },

      // 处理主控设备
      handleMasterDevice(row) {
         const device = this.dataList.filter(item => {
            return item.sn === row.sn;
         }).find(item => {
            return item.isMasterDevice;
         })
         return device ? `${device.name}（${this.getDeviceTypeName(device.type)}）>` : '未设置主控设备 >';
      },

      // 处理单元格合并
      handleSpanMethod({ row, column, rowIndex, columnIndex }) {
         // 第一列和最后一列（序列号和主控设备）合并逻辑
         if (columnIndex === 0 || columnIndex === 3) {
            // 找到当前行所在组的第一行索引
            let firstIndex = rowIndex
            while (firstIndex > 0 && this.dataList[firstIndex - 1].sn === row.sn) {
               firstIndex--
            }
            // 如果不是组内第一行，则隐藏
            if (firstIndex !== rowIndex) {
               return { rowspan: 0, colspan: 0 }
            }
            // 计算需要合并的行数
            let rowspan = 1
            let i = rowIndex + 1
            while (i < this.dataList.length && this.dataList[i].sn === row.sn) {
               rowspan++
               i++
            }
            return { rowspan, colspan: 1 }
         }

         // 第二列（已绑设备信息）合并逻辑
         if (columnIndex === 1) {
            // 找到当前行所在相同设备组的第一行索引
            let firstIndex = rowIndex
            while (firstIndex > 0 &&
               this.dataList[firstIndex - 1].sn === row.sn &&
               this.dataList[firstIndex - 1].name === row.name &&
               this.dataList[firstIndex - 1].type === row.type) {
               firstIndex--
            }
            // 如果不是组内第一行，则隐藏
            if (firstIndex !== rowIndex) {
               return { rowspan: 0, colspan: 0 }
            }
            // 计算需要合并的行数
            let rowspan = 1
            let i = rowIndex + 1
            while (i < this.dataList.length &&
               this.dataList[i].sn === row.sn &&
               this.dataList[i].name === row.name &&
               this.dataList[i].type === row.type) {
               rowspan++
               i++
            }
            return { rowspan, colspan: 1 }
         }
      }
   },
}
</script>

<style scoped>
.initial-state {
   flex: 1;
   padding: 0px 20px;
}

.tip-box {
   position: relative;
   display: flex;
   align-items: center;
   margin-top: 20px;
   padding: 9px 16px;
   background-color: #FCF6EC;
   border-radius: 2px;
   overflow: hidden;
}

.tip-line {
   position: absolute;
   left: 0;
   top: 0;
   width: 4px;
   height: 40px;
   background-color: #E6A23C;
}

.tips-text {
   color: #606266;
   font-size: 13px;
   font-family: PingFang SC;
   font-weight: 400;
   line-height: 22px;
}

.status-title {
   font-size: 16px;
   color: #333333;
   margin-bottom: 20px;
}

.custom-table {
   width: 100%;
   border-collapse: collapse;
   border: 1px solid #dfe6ec;
}

.custom-table th,
.custom-table td {
   height: 40px;
   font-size: 14px;
   text-align: center;
   border: 1px solid #dfe6ec;
}

.custom-table th {
   background-color: #eef1f6;
   color: #1f2d3d;
   font-weight: bold;
}

.custom-table td {
   color: #1f2d3d;
}

.text-button {
   background: none;
   border: none;
   color: #409EFF;
   cursor: pointer;
   padding: 0;
}

.text-button:hover {
   color: #66B1FF;
}

.label-controlled {
   padding: 2px 4px;
   color: #20a0ff;
   background: rgba(64, 95, 255, 0.10);
   font-size: 12px;
   border-radius: 2px;
}

.button-uncontrol {
   color: red;
}
</style>


// WEBPACK FOOTER //
// MasterDevice.vue?536a4494